module.exports = __webpack_public_path__ + "media/images/landing/second/photo21-f2db6e036d4956404e2a774521c0a6ca.jpg";